import { render } from "./AgendarQuadrasView.vue?vue&type=template&id=05c477ad&scoped=true"
import script from "./AgendarQuadrasView.vue?vue&type=script&lang=js"
export * from "./AgendarQuadrasView.vue?vue&type=script&lang=js"

import "./AgendarQuadrasView.vue?vue&type=style&index=0&id=05c477ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c477ad"]])

export default __exports__